import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "../../fleet/schemas/public";

// ============================================================================
// vehicles — รถเช่า (ข้อมูลรถดึงจาก fleet_vehicles ผ่าน JOIN)
// ============================================================================
export const vehicles = sqliteTable("car_rental_vehicles", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  fleetVehicleId: text("fleet_vehicle_id").notNull().references(() => fleetVehicles.id), // FK → fleet_vehicles.id
  // Calculation method
  calculationMethod: text("calculation_method").notNull().default("24_hour_cycle"), // "24_hour_cycle" | "daily"
  dailyCutoffTime: text("daily_cutoff_time"), // e.g. "20:00" — เวลาที่ถือว่าเป็นวันใหม่ (ใช้กับ daily mode)
  // Rental-specific pricing
  dailyRate: real("daily_rate").notNull().default(0),
  hourlyRate: real("hourly_rate").default(0),
  securityDeposit: real("security_deposit").default(0),
  driverRatePerDay: real("driver_rate_per_day").default(0),
  hasDriver: integer("has_driver").notNull().default(0),
  lateFeePerHour: real("late_fee_per_hour").default(0),
  gracePeriodHours: integer("grace_period_hours").default(0),
  extraDayThresholdHours: integer("extra_day_threshold_hours").default(0),
  // Status
  isRented: integer("is_rented").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  // Timestamps & Audit
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyActiveIdx: index("rv_company_active_idx").on(table.companyId, table.isActive),
}));

export type Vehicle = typeof vehicles.$inferSelect;
export type NewVehicle = typeof vehicles.$inferInsert;
